import React, { useEffect } from 'react';
import './SessionConflictPage.css'; // Optional: for styling
import Cookies from 'js-cookie';
import { useAppDispatch } from 'app/hooks';
import { clearAuthData, removeAccessToken, removeUserId } from 'utils/sessionStorage';

interface Props {}

const SessionConflictPage = (props: Props) => {
  const dispatch:any = useAppDispatch();

  useEffect(() => {
    // Clear all session data when component mounts
    clearAuthData();
    // Clear cookies as well for backward compatibility
    removeAccessToken();
    removeUserId();
    Cookies.remove('refresh_token');
  }, []);

  const handleLogout = () => {
    // dispatch(logout());
    clearAuthData();
    window.location.href = '/#/public/login';
  };

  return (
    <div className="conflict-container">
      <div className="conflict-card">
        <h1>Session Expired</h1>
        <p>
          Your session has expired. Please sign in again to continue using the application.
        </p>
        <button type={'submit'} onClick={handleLogout} className="logout-button">
          Continue to Login Page
        </button>
      </div>
    </div>
  );
};

export default SessionConflictPage;
